module.exports = __webpack_public_path__ + "img/about_dayi.490c35e4.svg";